import React, { useMemo } from 'react';
import T from 'prop-types';

import RadioButtonGroup from '../../../RadioButtonGroup';

const countSelectedRegions = (countriesIso, regionsList) =>
  regionsList.reduce((result, { list }) => {
    if (new Set([...countriesIso, ...list]).size === countriesIso.length) {
      return result + 1;
    }

    return result;
  }, 0);

export const geoGranularities = [
  ['country', 'Split by country'],
  ['custom', 'Aggregate all countries and regions'],
  ['region', 'Split by region'],
];
const makeOptions = (countriesIso = [], regionsList, { splitByCountryOnly }) => {
  const isWW = countriesIso.includes('WW');

  const disabledByGeoGranularity = {
    country: isWW,
    custom: splitByCountryOnly,
    region:
      splitByCountryOnly || isWW || (!isWW && countSelectedRegions(countriesIso, regionsList) < 2),
  };

  return geoGranularities.map(([value, text]) => ({
    id: value,
    value,
    text,
    disabled: disabledByGeoGranularity[value],
  }));
};

const GeoGranularity = ({
  active,
  regionsList,
  countriesIso,
  splitByCountryOnly = false,
  onChange,
}) => {
  const options = useMemo(
    () => makeOptions(countriesIso, regionsList, { splitByCountryOnly }),
    [countriesIso, regionsList, splitByCountryOnly]
  );

  return (
    <section className="export-settings-section">
      <div className="export-settings-section__about">
        <h4 className="h5 export-settings-section__title">Geographic Granularity</h4>
        <p className="paragraph-md export-settings-section__description">
          Determines how we split up the data by geography.
        </p>
      </div>
      <div className="export-settings-section__content">
        <RadioButtonGroup
          active={active}
          options={options}
          name="geo-granularity"
          className="export-settings-section__options geo-granularity-options"
          enabled
          onChange={onChange}
        />
      </div>
    </section>
  );
};

GeoGranularity.propTypes = {
  active: T.string.isRequired,
  regionsList: T.array.isRequired,
  countriesIso: T.array.isRequired,
  splitByCountryOnly: T.bool,
  onChange: T.func.isRequired,
};

export default GeoGranularity;
